import state from './state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./app/resource/global/store/index.js